import {
  IconBuilding,
  IconCalendar,
  IconClock,
  IconHome,
  IconKey,
  IconTrash,
  IconUsers,
} from '@tabler/icons-react';
import { activeTab } from '../types/dashboard.types';
import { Card, CardBody, Col, Row } from 'reactstrap';
import { StatsMetrics } from '../models/dashboardModels';

interface Props {
  activeTab: activeTab;
  stats: StatsMetrics;
}

const MetricsDashboardLegacy = ({ activeTab, stats }: Props) => {
  const getTotalIcon = () => {
    switch (activeTab) {
      case 'pre-sale':
        return <IconHome size={24} className="text-primary" />;
      case 'rent':
      case 'secondary':
        return <IconKey size={24} className="text-primary" />;
      default:
        return <IconUsers size={24} className="text-primary" />;
    }
  };

  const getTotalLabel = () => {
    switch (activeTab) {
      case 'pre-sale':
        return 'Asesorias';
      case 'rent':
      case 'secondary':
        return 'Visitas';
      default:
        return 'Total Visits';
    }
  };

  return (
    <Row>
      <Col lg={2} md={4} sm={6} className="mb-3">
        <Card className="border-primary">
          <CardBody>
            <div className="d-flex justify-content-between align-items-center">
              <div>
                <h6 className="text-muted mb-1">{getTotalLabel()}</h6>
                <h2 className="mb-0 text-primary">{stats.total}</h2>
              </div>
              {getTotalIcon()}
            </div>
          </CardBody>
        </Card>
      </Col>
      <Col lg={2} md={4} sm={6} className="mb-3">
        <Card className="border-warning">
          <CardBody>
            <div className="d-flex justify-content-between align-items-center">
              <div>
                <h6 className="text-muted mb-1">Pendiente de aprobación</h6>
                <h2 className="mb-0 text-warning">{stats.pending_approval}</h2>
              </div>
              <IconClock size={24} className="text-warning" />
            </div>
          </CardBody>
        </Card>
      </Col>
      <Col lg={2} md={4} sm={6} className="mb-3">
        <Card className="border-info">
          <CardBody>
            <div className="d-flex justify-content-between align-items-center">
              <div>
                <h6 className="text-muted mb-1">Programada</h6>
                <h2 className="mb-0 text-info">{stats.scheduled}</h2>
              </div>
              <IconClock size={24} className="text-info" />
            </div>
          </CardBody>
        </Card>
      </Col>
      <Col lg={2} md={4} sm={6} className="mb-3">
        <Card className="border-warning">
          <CardBody>
            <div className="d-flex justify-content-between align-items-center">
              <div>
                <h6 className="text-muted mb-1">Re programada</h6>
                <h2 className="mb-0 text-warning">{stats.rescheduled}</h2>
              </div>
              <IconCalendar size={24} className="text-warning" />
            </div>
          </CardBody>
        </Card>
      </Col>
      <Col lg={2} md={4} sm={6} className="mb-3">
        <Card className="border-success">
          <CardBody>
            <div className="d-flex justify-content-between align-items-center">
              <div>
                <h6 className="text-muted mb-1">Finalizada</h6>
                <h2 className="mb-0 text-success">{stats.done}</h2>
              </div>
              <IconBuilding size={24} className="text-success" />
            </div>
          </CardBody>
        </Card>
      </Col>
      <Col lg={2} md={4} sm={6} className="mb-3">
        <Card className="border-danger">
          <CardBody>
            <div className="d-flex justify-content-between align-items-center">
              {activeTab === 'pre-sale' ? (
                <div className="d-flex" style={{ gap: '1.5rem' }}>
                  <div>
                    <h2 className="mb-0 text-danger">{stats.cancelled}</h2>
                    <h6 className="text-muted mb-0">Cancelada</h6>
                  </div>
                  <div>
                    <h2 className="mb-0 text-danger">{stats.voided}</h2>
                    <h6 className="text-muted mb-0">Anulada</h6>
                  </div>
                </div>
              ) : (
                <div>
                  <h6 className="text-muted mb-1">Cancelada</h6>
                  <h2 className="mb-0 text-danger">{stats.cancelled}</h2>
                </div>
              )}
              <IconTrash size={24} className="text-danger" />
            </div>
          </CardBody>
        </Card>
      </Col>
    </Row>
  );
};

export default MetricsDashboardLegacy;
